
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D80027","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M256 256L0 90.691v44.242L155.826 256 0 377.067v44.242z"}}),_c('path',{attrs:{"d":"M0 90.691v330.618L189.217 256z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M44.184 213.36l24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"}})])
          )
        }
      }
    